import { Resolver, useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { useWagmiAuth } from 'app/providers';
import { ZERO_ADDRESS } from 'shared';
import Web3 from 'web3';
import * as Yup from 'yup';

export interface UseBuyFormArgs {
  stableTokenBalance: string;
  maxValue: string;
}

export interface FormData {
  stablesAmount: string;
  fatherAddress: string;
}

const defaultValues: FormData = {
  stablesAmount: '',
  fatherAddress: '',
};

const MIN_BUY = 10;

export const useBuyForm = ({ stableTokenBalance, maxValue }: UseBuyFormArgs) => {
  const { state: authState } = useWagmiAuth();

  const validationSchema = Yup.object().shape({
    stablesAmount: Yup.string()
      .test('Check balance', 'Insufficient balance', (val) => {
        return Number(val) <= Number(stableTokenBalance);
      })
      .test('Min value', `Minimum purchase is ${MIN_BUY}`, (val) => {
        return Number(val) >= MIN_BUY;
      })
      .test('Max value', 'This number of coins is not available for purchase', (val) => {
        return Number(val) <= Number(maxValue);
      })
      .required('Enter the number of stablecoins'),

    fatherAddress: Yup.string().test('Address', 'Invalid address', (val) => {
      if (!val) {
        return true;
      }

      return (
        !!val &&
        val.toLocaleLowerCase() !== authState.address.toLocaleLowerCase() &&
        val !== ZERO_ADDRESS &&
        Web3.utils.isAddress(val)
      );
    }),
  });

  const form = useForm<FormData>({
    defaultValues,
    resolver: yupResolver(validationSchema) as Resolver<FormData, any>,
    mode: 'onChange',
  });

  return form;
};
